var _defs, _rect;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTitleBg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlnsSvgjs: "http://svgjs.dev/svgjs",
    viewBox: "0 0 700 700",
    width: 700,
    height: 700,
    opacity: 1,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    gradientTransform: "rotate(106, 0.5, 0.5)",
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "ffflux-gradient"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9333ea",
    stopOpacity: 1,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#db2777",
    stopOpacity: 1,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "ffflux-filter",
    x: "-20%",
    y: "-20%",
    width: "140%",
    height: "140%",
    filterUnits: "objectBoundingBox",
    primitiveUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feTurbulence", {
    type: "fractalNoise",
    baseFrequency: "0.007 0.004",
    numOctaves: 2,
    seed: 2,
    stitchTiles: "stitch",
    x: "0%",
    y: "0%",
    width: "100%",
    height: "100%",
    result: "turbulence"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: "17 6",
    x: "0%",
    y: "0%",
    width: "100%",
    height: "100%",
    in: "turbulence",
    edgeMode: "duplicate",
    result: "blur"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "soft-light",
    x: "0%",
    y: "0%",
    width: "100%",
    height: "100%",
    in: "SourceGraphic",
    in2: "blur",
    result: "blend"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 700,
    height: 700,
    fill: "url(#ffflux-gradient)",
    filter: "url(#ffflux-filter)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTitleBg);
export default __webpack_public_path__ + "static/media/title-bg.b9ed1e3f1bdaaadedb57994a1f01f54c.svg";
export { ForwardRef as ReactComponent };